import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';

import { Select, FormLabel } from '~ui-kit';

const Control = ({ children, ...props }) => {
  const { value } = props.selectProps;

  return (
    <components.Control {...props}>
      {value?.value && <ActivityIcon status={value.value} />}
      {children}
    </components.Control>
  );
};

const Option = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <OptionWrapper>
        <ActivityIcon status={props.data.value} /> {children}
      </OptionWrapper>
    </components.Option>
  );
};

const Urgency = ({
  value,
  onChange,
  label,
  required,
  info,
  options,
  error,
}) => {
  return (
    <Container>
      <FormLabel required={required} info={info}>
        {label}
      </FormLabel>
      <Select
        placeholder="Valitse"
        options={options || []}
        value={value}
        onChange={onChange}
        components={{ Control, Option }}
        isSearchable={false}
        error={error}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const ActivityIcon = styled.div`
  box-sizing: border-box;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  padding-top: 3px;
  background-color: ${props => {
    switch (props.status) {
      case 'DFLT':
        return '#0E86CA';
      case 'URGN':
        return '#FF9D2A';
      case 'CRIT':
        return '#EF0A0A';
      default:
        return 'white';
    }
  }};
  margin-left: 8px;
  margin-top: 2px;
`;

const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export default Urgency;
